import { render, staticRenderFns } from "./MySpaceTasksSummaryWidget.vue?vue&type=template&id=78d009d3&"
import script from "./MySpaceTasksSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./MySpaceTasksSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports